

































































































/* eslint-disable class-methods-use-this */


import { Vue, Component, Watch } from "vue-property-decorator";
import { inject, ref } from "vue";
import { mapState, mapMutations, mapGetters } from "vuex";
import { Location } from "vue-router";
import deepEqual from "fast-deep-equal";
import format from "date-fns/format";
import colors from "vuetify/es5/util/colors";
import { startOfDay, endOfDay } from "date-fns";
import debounce from "lodash.debounce";
import throttle from "lodash.throttle";
import qs from "query-string";
import { NewsItem } from "@/store/modules/newsItems/types.d";
import CdkNavigationProvider from "@/components/CdkNavigation/CdkNavigationProvider.vue";
import CdkNewsItem from "@/components/CdkNewsItem/CdkNewsItem.vue";
import SlcSelectionControls from "@/components/SlcCollab/SlcSelectionControls.vue";
import List from "@/views/List.vue";
import { isTablet } from "@/utils/responsive";
import shortcuts from "@/constants/shortcuts";

// news item detail
import useMarkAsFavorite from "@/composition/useMarkAsFavorite";
import useAuthentication from "@/composition/useAuthentication";
import CdkFavoriteButton from "@/components/CdkFavorite/CdkFavoriteButton.vue";
import { NewsItemDetail } from "@/components/CdkNewsItem/types.d";

// filter pass badges
import api from "@/api";
import {
  FilterPassBadge,
  createFilterPassBadge,
  filterIsVisible,
  sortByIsPublic
} from "@/utils/filterPassBadges";
import CdkFilterPassBadges from "@/components/CdkFilterPassBadge/CdkFilterPassBadges.vue";

// filter rules
import useSetFilterRules from "@/composition/useSetFilterRules";

import useCurrentView from "@/composition/useCurrentView";
import useMatomoEvent from "@/composition/useMatomoEvent";
import SlcShareSearchDialog from "../components/SlcShareSearch/SlcShareSearchDialog.vue";
import SlcSaveSearchDialog from "../components/SlcSaveSearch/SlcSaveSearchDialog.vue";
import useNewsItemsPolling from "@/composition/useNewsItemsPolling";
import intervalId from "@/composition/pollingState";
import maxZIndex from "@/views/lib/useMaxZIndex";

const DEFAULT_SHORTCUT = shortcuts.find(shortcut => shortcut.default);

@Component({
  // @ts-ignore
  setup() {
    const eventBus = inject("eventBus");
    const { validateAndRetrieveToken, isAuthenticated } = useAuthentication();
    const { toggleFavorite } = useMarkAsFavorite();
    const { handleTagClick } = useSetFilterRules();
    const { currentView } = useCurrentView();

    const onFavoriteButtonClick = () => {
      useMatomoEvent({
        category: `${currentView.value} View`,
        action: 'Click "Als Favorit speichern"',
        name: "Als Favorit speichern"
      });
    };

    const { setPollingInterval } = useNewsItemsPolling();

    const appliedFilterRules = ref([]);

    const filterPassBadges: FilterPassBadge[] = [];

    const comboboxMenu = ref(false);

    const loadMore = ref(false);

    return {
      toggleFavorite,
      handleTagClick,
      eventBus,
      token: validateAndRetrieveToken,
      isAuthenticated,
      onFavoriteButtonClick,
      setPollingInterval,
      intervalId,
      appliedFilterRules,
      comboboxMenu,
      filterPassBadges,
      loadMore
    };
  },
  components: {
    list: List,
    daily: List,
    CdkNavigationProvider,
    CdkNewsItem,
    CdkFavoriteButton,
    CdkFilterPassBadges,
    SlcSelectionControls,
    SlcShareSearchDialog,
    SlcSaveSearchDialog
  },
  computed: {
    ...mapState("collaboration", ["isSidebarVisible"]),
    ...mapState("conceptItems", ["genres", "ressorts"]),
    ...mapState("filterRules", {
      urgencyFilterRule: ({ filterRules }) =>
        filterRules.find(({ type }) => type === "FILTER_URGENCY")
    }),
    ...mapState("newsItems", ["newsItems"]),
    ...mapGetters("newsItems", ["getNewItemByGUID"]),
    ...mapGetters("filters", ["getFilterByLink"]),
    ...mapGetters("filterRules", ["getFilterRulesByType"]),
    ...mapGetters("collaboration", ["isSelectionEnabled"])
  },
  methods: {
    ...mapMutations("ui", ["setRight"]),
    ...mapMutations("collaboration", ["closeSidebar"])
  }
})

export default class Feed extends Vue {
  comboboxMenu;

  appliedFilterRules;

  eventBus;

  urgencyFilterRule: any;

  // Authentication
  token: Function;

  isAuthenticated: boolean;

  // news item detail
  getNewItemByGUID;

  // filter pass badges
  filters!: string[];

  filterPassBadges: FilterPassBadge[] = [];

  getFilterByLink;

  isSidebarVisible: boolean;

  closeSidebar;

  getFilterRulesByType;

  loadMore = false;

  newsItems: NewsItem[];

  get hasUrgentFilterRule(): boolean {
    return (
      !!this.urgencyFilterRule &&
      deepEqual(this.urgencyFilterRule.values, ["1", "2"])
    );
  }

  get viewMode(): string {
    return this.$route.params.viewMode;
  }

  get startDate(): string {
    return String(this.$route.query.startDate);
  }

  get endDate(): string {
    return String(this.$route.query.endDate);
  }

  get isLoading(): boolean {
    return this.$store.state.newsItems.isLoading;
  }

  get view() {
    const { view } = this.$route.query;

    return view;
  }

  get sortOrder() {
    const { sortOrder } = this.$route.query;

    return sortOrder;
  }

  get filterRules() {
    return this.$store.state.filterRules.filterRules;
  }

  get filterRulesByType() {
    return this.getFilterRulesByType(
      "FILTER_FULLTEXT"
    );
  }

  get currentFilter() {
    return this.$store.getters["filters/getFilterById"](
      this.$route.query.filterId
    );
  }

  @Watch("currentFilter", { immediate: true })
  onCurrentFilterChange() {
    if (!this.currentFilter) {
      const newQuery = { ...this.$route.query };
      delete newQuery.filterId;
      this.$router.push({ query: newQuery });
    }

  }

  get guid(): string {
    return this.$store.state.route.params.id;
  }

  get detailClosedLocation(): Location {
    const { path, params, query } = this.$route;
    let newPath = path;
    const newParams = { ...params };

    if (newParams.id) {
      newPath = `/newsitems/${params.viewMode}`;
      delete newParams.id;
      delete query.shortcut;
    }

    return {
      path: newPath,
      params: newParams,
      query
    };
  }

  @Watch("isAuthenticated", { immediate: true })
  onIsAuthenticatedChange() {
    if (this.isAuthenticated) {
      this.fetchNewsItems();
    }
  }

  @Watch("startDate", { immediate: true })
  onStartDateChange() {
    if (this.isAuthenticated) {
      this.fetchNewsItems();
    }
  }

  @Watch("endDate", { immediate: true })
  onEndDateChange() {
    if (this.isAuthenticated) {
      this.fetchNewsItems();
    }
  }

  @Watch("view")
  onViewChange() {
    this.fetchNewsItems();
  }

  @Watch("sortOrder")
  onSortOrderChange() {
    this.fetchNewsItems();
  }

  @Watch("filterRules")
  onFilterRulesChange(currentRules) {
    const filterRules = [
      ...currentRules.map(filterRule => ({ ...filterRule }))
    ];
    const filterRulesChanged = !deepEqual(
      filterRules,
      this.appliedFilterRules.map(filterRule => ({ ...filterRule }))
    );
    if (filterRulesChanged) {
      this.fetchNewsItems();
      this.appliedFilterRules = [...currentRules];
    }
  }

  // eslint-disable-next-line func-names
  get fetchNewsItems() { return debounce(function() {
    // @ts-ignore;
    const {
      startDate,
      endDate,
      sortOrder,
      $router,
      $route
      // @ts-ignore;
    } = this;

    function addDefaultQueryParam(obj) {
      $router.replace({
        query: {
          ...$route.query,
          ...obj
        }
      });
    }

    if (startDate === "undefined") {
      addDefaultQueryParam({
        startDate: format(new Date(), "YYYY-MM-DD")
      });
    }

    if (endDate === "undefined") {
      addDefaultQueryParam({
        endDate: format(new Date(), "YYYY-MM-DD")
      });
    }

    if (sortOrder === undefined) {
      addDefaultQueryParam({
        sortOrder: "desc"
      });
    }

    // @ts-ignore
    const shouldLoadMore = this.loadMore && this.newsItems?.length < this.$store.state.newsItems.totalResults;
    // @ts-ignore;
    const fromDate = (this.startDate === undefined || this.startDate === "undefined") ? new Date(format(new Date(), "YYYY-MM-DD")).toISOString() : new Date(startOfDay(this.startDate)).toISOString();
    // @ts-ignore;
    const toDate = (this.endDate === undefined || this.endDate === "undefined") ? new Date(format(new Date(), "YYYY-MM-DD")).toISOString() : new Date(endOfDay(this.endDate)).toISOString();
    // @ts-ignore;
    this.$store.dispatch("newsItems/fetchNewsItems", {
      type: shouldLoadMore ? "loadMore" : "query",
      from: fromDate,
      to: toDate,
      ...(sortOrder ? { sortOrder } : {})
    });
    // @ts-ignore
    this.loadMore = false;

    // @ts-ignore
    if (intervalId.value === undefined) this.setPollingInterval();
  }, 0, { leading: true });}

  /**
   * Synchronizes the navigation drawer value with the ui store and updates
   * the router to remove the id from routing params in case the drawer is
   * closed.
   * @param  {Boolean} isVisible
   * @return {undefined}
   */
  setRight;

  syncNavigationDrawer(isVisible) {
    if (!isVisible) {
      this.$router.push(this.detailClosedLocation);
    }

    this.setRight(isVisible);
  }

  /**
   * Workaround to get urgency into upper scope
   * Partially duplicated in newsItemProvider
   * @see: https://jira.mecom.de/browse/EC-612
   */
  urgency: number = 0;

  handleNewsItemLoaded(newsItem: NewsItemDetail): void {
    this.urgency = newsItem.urgency;
  }

  get isUrgent(): boolean {
    return this.urgency === 1 || this.urgency === 2;
  }

  get backgroundColor(): string {
    return this.isUrgent ? colors.red.lighten5 : "#fff";
  }

  get navigationDrawerStyle(): any {
    // EC-627: detail view height should be 100% if on tablet breakpoint
    const appBarHeight = isTablet(this) ? 0 : 64;

    return {
      top: `${2 * appBarHeight}px`,
      height: `calc(100% - ${2 * appBarHeight}px)`,
      backgroundColor: this.backgroundColor,
      zIndex:
          maxZIndex.value +
          (isTablet(this) ? 150 : 30)
    };
  }

  get displayFrcOverlay(): boolean {
    return !isTablet(this);
  }

  // end workaround

  /**
   * Returns weather the current news item is marked as favorite
   */
  get isFavorite(): Boolean {
    const isFavorite = this.newsItem ? this.newsItem.isFavorite : false;

    return isFavorite;
  }

  /**
   * Returns the currently selected news item
   */

  get newsItem(): NewsItemDetail | null {
    if (this.guid) {
      return this.getNewItemByGUID(this.guid);
    }
    return null;
  }

  /**
   * When the news item gets clicked,
   * and the right sided detail view opens,
   * the sidebar shall be closed
   */

  @Watch("newsItem")
  onNewsItemClick() {
    if (this.newsItem && this.isSidebarVisible) {
      this.closeSidebar();
    }
  }

  @Watch("loadMore", { deep: true, immediate: true })
  onLoadMoreChange(loadMore: boolean) {
    if (
      loadMore &&
      this.newsItems?.length < this.$store.state.newsItems.totalResults
    ) {
      this.fetchNewsItems();
    }
  }

  // filter pass badges

  /**
   * Fetches filters for a given news item id and returns a promise
   * with filter payload.
   */
  async fetchFilterPassBadgesById(
    guid: string,
    token: string
  ): Promise<string[]> {
    const get = qs.stringify({ view: "filter_only" });
    const post = [
      {
        type: "FILTER_GUID",
        values: [guid]
      }
    ];
    const url = `newsitems?${get}`;
    const filters: any = await api.post({
      url,
      payload: post,
      authJWT: token
    });

    return filters[0].filterPassBadges;
  }

  /**
   * When the news item guid changes, fetch only its filter pass badges from
   * the select news item service.
   */
  @Watch("guid", { immediate: true })
  onGuidChange() {
    if (this.guid) {
      this.fetchFilterPassBadgesById(this.guid, this.token()).then(
        filterPassBadges => {
          this.filterPassBadges = this.mapFilterPassBadges(filterPassBadges);
        }
      );
    }
  }

  /**
   * Maps filters to filter pass badges and change view model.
   */
  mapFilterPassBadges(filters: String[]): FilterPassBadge[] {
    return filters
      .filter(uri => !!this.getFilterByLink(uri))
      .map(uri => createFilterPassBadge(this.getFilterByLink(uri)))
      .filter(filterIsVisible)
      .sort(sortByIsPublic);
  }

  mounted() {
    this.eventBus.$on("frc-toggled", val => {
      this.comboboxMenu = val;
    });

    this.eventBus.$on("refresh-feed", () => {
      this.fetchNewsItems();
    });

    // EC-822 set default shortcut in query
    if (!this.$route.query.shortcut && DEFAULT_SHORTCUT) {
      this.$router.push({
        query: {
          ...this.$route.query,
          shortcut: DEFAULT_SHORTCUT.title
        }
      });
    }

    window.onscroll = throttle(() => {
      const TRIGGER_OFFSET_FROM_BOTTOM: number = window.screen.height;

      const bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight >=
        document.documentElement.offsetHeight - TRIGGER_OFFSET_FROM_BOTTOM;
      if (this.loadMore !== bottomOfWindow) {
        this.loadMore = bottomOfWindow;
      }
    }, 500);
  }
}
